import React from 'react';
import PropTypes from 'prop-types';

import { Table } from 'components';

import { formatUnitString } from 'utils/formatString';

import classNames from 'classnames/bind';
import styles from './styles.pcss';
const cx = classNames.bind(styles);

const SpendingStructureTable = ({
  structure,
  currency,
  isPorted,
}) => {
  if (!structure) {
    return null;
  }

  return (
    <Table
      data={structure.filter((item) => !item.hidden)}
      config={{
        columns: [
          {
            name: 'detalization.expenses.spendingStructure.service',
            dataField: 'name',
            transformer: (row) => (
              <span className={cx(`nestedLevel${row.nestingLevel}`)}>
                {row.name}
              </span>
            ),
          },
          !isPorted && (
            {
              name: 'detalization.expenses.spendingStructure.volume',
              dataField: 'volume',
              transformer: ({ volume, unit }) => {
                if (!volume) {
                  return '—';
                }

                const trafficVolume = Math.round(parseFloat(volume) * 100) / 100;

                if (!unit) {
                  return trafficVolume;
                }

                return formatUnitString(trafficVolume, unit);
              },
              hideOnMobile: true,
              width: '130px',
            }
          ),
          {
            name: 'detalization.expenses.spendingStructure.sum',
            dataField: 'sum',
            transformer: (row) => (
              <span className={cx('sumCell')}>
                {formatUnitString(row.sum, currency)}
              </span>
            ),
            width: '80px',
          },
        ],
        uniqueIdField: 'aggregateCode',
      }}
    />
  );
};

SpendingStructureTable.propTypes = {
  structure: PropTypes.array,
  currency: PropTypes.string,
  isPorted: PropTypes.bool,
};

export default SpendingStructureTable;
